// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/matrix/matrix.proto" (package "mlmbox.client.matrix", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Matrix } from "./matrix.ts";
import type { Matrix_Position } from "../../types/account.ts";
import type { Matrix_Reinvest_Request } from "../../types/account.ts";
import type { Matrix_View } from "../../types/account.ts";
import type { PositionView_Team } from "../../types/account.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Matrix_Info } from "../../types/account.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.matrix.Matrix
 */
export interface IMatrixClient {
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Matrix.Info);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Matrix_Info>;
    /**
     * @generated from protobuf rpc: View(mlmbox.types.PositionView.Team) returns (mlmbox.types.Matrix.View);
     */
    view(input: PositionView_Team, options?: RpcOptions): UnaryCall<PositionView_Team, Matrix_View>;
    /**
     * @generated from protobuf rpc: SetReinvestConfig(mlmbox.types.Matrix.Reinvest.Request) returns (mlmbox.types.Matrix.Position);
     */
    setReinvestConfig(input: Matrix_Reinvest_Request, options?: RpcOptions): UnaryCall<Matrix_Reinvest_Request, Matrix_Position>;
}
/**
 * @generated from protobuf service mlmbox.client.matrix.Matrix
 */
export class MatrixClient implements IMatrixClient, ServiceInfo {
    typeName = Matrix.typeName;
    methods = Matrix.methods;
    options = Matrix.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Matrix.Info);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Matrix_Info> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Matrix_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: View(mlmbox.types.PositionView.Team) returns (mlmbox.types.Matrix.View);
     */
    view(input: PositionView_Team, options?: RpcOptions): UnaryCall<PositionView_Team, Matrix_View> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<PositionView_Team, Matrix_View>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetReinvestConfig(mlmbox.types.Matrix.Reinvest.Request) returns (mlmbox.types.Matrix.Position);
     */
    setReinvestConfig(input: Matrix_Reinvest_Request, options?: RpcOptions): UnaryCall<Matrix_Reinvest_Request, Matrix_Position> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<Matrix_Reinvest_Request, Matrix_Position>("unary", this._transport, method, opt, input);
    }
}
